<template>
  <div v-if="ready">
    <!-- <div style="color:#fff">
      <h3>Moh lun's guiding tips</h3>
      <div>Latest trade: {{latestTrade}}</div>
    </div>-->
    <!-- <button @click="simulate()" style="color: #fff;">Simulate</button>
    <div>Best Buy{{ provider.bestBuy }}</div>
    <div>Best Sell {{ provider.bestSell }}</div>-->

    <div id="trade-data-section" class="exchange-com">
      <div class="d-flex flex-wrap mb-2">
        <div id="left-container">
          <Market
            class="market-section-wrap"
            ref="market"
            :market-list-group="provider.marketListGroup"
            :market-list="provider.marketList"
            :clickable="!provider.recoveryMode"
          />
          <TradeHistory ref="tradeHistory" :model="provider.tradeHistory" @rowClick="price = $event"/>
        </div>
        <div id="trade-view-container" class="d-flex flex-column">
          <v-expansion-panels v-model="tradeViewExpand" class="active-pair-bar mb-1 d-block"
                              id="trade-view-inner-container">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div id="market-pair-trade-details" class="d-flex flex-wrap justify-start align-center"
                     style="zoom:90%">
                  <div class="mr-3 font-15 font-weight-bold active-pair-font">{{ convertPair(currentMarket) }}</div>
                  <div class="mr-3 font-12 active-pair-font">
                    {{ convertDecimal(currentMarket.usd, currentMarket.priceDec) || '--' }}
                  </div>
                  <div class="mr-3 font-12 active-pair-font">
                    ≈
                    {{
                    `${Getter_Current_Currency.symbol}${convertDecimal(
                    currentMarket.usd * Getter_Current_Currency.rate,
                    currentMarket.priceDec
                    )}` || '--'
                    }}
                  </div>
                  <div class="mr-3 font-12 active-pair-font">
                    {{ $t('labels.trade.24change') }}
                    <span
                      class="increase-down"
                      :class="{ 'color-buy': currentMarket.change > 0, 'color-sell': currentMarket.change < 0 }"
                    >{{
                        typeof currentMarket.change === 'undefined' ? '--' : parseFloat(currentMarket.change).toFixed(2)
                      }}%</span
                    >
                  </div>
                  <div class="mr-3 font-12 active-pair-font">
                    {{ $t('labels.trade.24high') }} {{ convertDecimal(currentMarket.high, currentMarket.priceDec) ||
                    '--' }}
                  </div>
                  <div class="mr-3 font-12 active-pair-font">
                    {{ $t('labels.trade.24low') }} {{ convertDecimal(currentMarket.low, currentMarket.priceDec) || '--'
                    }}
                  </div>
                  <div class="mr-3 font-12 active-pair-font">
                    {{ $t('labels.trade.24vol') }}
                    {{
                    typeof currentMarket.volume === 'undefined'
                    ? '--'
                    : convertDecimal(currentMarket.volume, currentMarket.volDec)
                    }}
                  </div>
                  <div
                    style="width: 6px; height: 6px; border-radius: 50%;"
                    :data-ping-pong="Getter_Socket_State ? (provider.pong ? 'pong' : 'connected') : 'disconnected'"
                  ></div>
                  <!-- <div class="ml-2">
                    <div class="ping-pong pong" :data-active="provider.pong"></div>
                    <div class="ping-pong ping" :data-active="provider.ping"></div>
                  </div>-->
                </div>
                <div class="chart-toggle-bar clearfix">
                  <a
                    href="javascript: void(0);"
                    class="chart-toggle-btn"
                    :class="chartView == 'kline' ? 'active' : ''"
                    @click.stop="kLineTypeClick(1)"
                  >{{ $t('dealProfessional.kLine.text') }}</a
                  >
                  <a
                    href="javascript: void(0);"
                    class="chart-toggle-btn"
                    :class="chartView == 'depth' ? 'active' : ''"
                    @click.stop="kLineTypeClick(3)"
                  >{{ $t('dealProfessional.depth.text') }}</a
                  >
                </div>
                <template v-slot:actions>
                  <v-icon color="#ffffff">$expand</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <TradeView
                  ref="trade_view"
                  v-show="chartView == 'kline'"
                  :model="provider.kline"
                  :realTimeData="realTimeKlineData"
                  :activePair="activePair"
                  :activeInterval="activeInterval"
                  @subscribeExchange="subscribeExchange"
                ></TradeView>

                <DepthChart
                  v-show="chartView == 'depth'"
                  ref="depthMap"
                  :buyChart="provider.buyChart"
                  :sellChart="provider.sellChart"
                ></DepthChart>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <PlaceOrder
            ref="placeOrder"
            :price="price"
            :volume="volume"
            :best-price="bestPrice"
            :account-data="userAccountData"
            @getUserAccountData="getUserAccountData"
            @cleanPrice="price = $event"
            @cleanVolume="volume = $event"
          />
          <div></div>
        </div>
        <DepthData
          id="depth-component-container"
          ref="depthData"
          :model="{
            buy: provider.buy,
            sell: provider.sell
          }"
          :depth-options="options.depth"
          :active-depth.sync="activeDepth"
          :last-price="provider.tradeHistory[0]"
          @rowClickPrice="price = $event"
          @rowClickVol="volume = $event"
          :propLastPrice="provider.activePair"
        ></DepthData>
      </div>
      <div>
        <MyTrade ref="myTrade" @getUserAccountData="getUserAccountData"/>
      </div>
    </div>

    <!-- ---------------------------------------------- -->
    <!-- <h4>Pair</h4>
    <select v-model="activePair">
      <option
        v-for="(item, index) in provider.marketList[activePairGroup]"
        :key="index"
        :value="index"
      >{{index}}</option>
    </select>
    <br />
    <br />

    <h4>Interval</h4>
    <select v-model="activeInterval">
      <option value="1m">1 minute</option>
      <option value="5m">5 minute</option>
      <option value="10m">10 minute</option>
    </select>
    <br />
    <br />

    <h4>Depth</h4>
    <select v-model="activeDepth">
      <option v-for="(item, index) in options.depth" :key="index" :value="item.value">{{item.text}}</option>
    </select>
    <br />
    <br />-->
  </div>
</template>

<script>
  import Provider from './Provider';
  import { mapActions, mapMutations, mapGetters } from 'vuex';
  import { getterTypes } from '@/store/getter-types';
  import { mutationTypes } from '@/store/mutation-types';
  import { assetsApi } from '@/api/assetsApi';
  import DefaultHeader from '@/components/Header/DefaultHeader';
  import Market from './components/Market';
  import TradeHistory from './components/TradeHistory';
  import DepthChart from './components/DepthChart';
  import DepthData from './components/DepthData';
  import TradeView from './components/TradeView';
  import PlaceOrder from './components/PlaceOrder';
  import MyTrade from './components/MyTrade';
  import tool from '@/common/js/tool';
  import { BigNumber } from 'bignumber.js';
  import { Howl } from "howler";


  export default {
    name: 'Exchange',
    components: {
      DefaultHeader,
      Market,
      TradeHistory,
      DepthChart,
      DepthData,
      TradeView,
      PlaceOrder,
      MyTrade
    },
    mixins: [Provider],
    computed: {
      ...mapGetters([
        getterTypes.Getter_Socket_State,
        getterTypes.Getter_Current_Market,
        getterTypes.Getter_Current_Currency,
        getterTypes.Getter_Token
      ]),
      klineInterval: value => {
        return !window.localStorage.getItem('chart.interval') ? '30' : window.localStorage.getItem('chart.interval');
      }
    },
    watch: {
      async Getter_Current_Market(value) {
        if (this.ready) {
          this.activePair = value.symbol;
          this.activePairGroup = value.marketCoin;
          this.activePairData = this.provider.marketList[this.activePairGroup][value.symbol];
          this.options.depth = this.getDepthGroupList();
          this.activeDepth = this.options.depth[this.options.depth.length - 1].value;
          this.lockActiveDepthWatch = true;
          this.price = null;
          await this.watch(this.activePair, this.activeDepth, this.activeInterval);
          this.lockActiveDepthWatch = false;
        }
      },
      activeDepth(value) {
        if (this.ready && !this.lockActiveDepthWatch) {
          this.watch(null, value, null);
        }
      },
      activeInterval(value) {
        if (this.ready) {
          this.watch(null, null, value);
        }
      },
      'provider.bestBuy'(value) {
        this.bestPrice = {
          bestBuy: value,
          bestSell: this.bestPrice.bestSell
        };
      },
      'provider.bestSell'(value) {
        this.bestPrice = {
          bestBuy: this.bestPrice.bestBuy,
          bestSell: value
        };
      },
      Getter_Socket_State(value) {
        if (value) {
          console.log('reconnect');
          this.init();
        }
      },
      latestTrade(value) {
        if (!value) {
          document.title = 'GRXTrade';
        } else {
          if (!value.price) {
            document.title = 'GRXTrade';
          } else {
            let price = new BigNumber(value.price);
            document.title =
              price.toFixed(this.currentMarket.priceDec) +
              ' | ' +
              this.currentMarket.coin +
              '-' +
              this.currentMarket.marketCoin +
              ' | ' +
              'GRXTrade';
          }
        }
      }
    },
    created() {
    },
    mounted() {

      if (document.getElementById('udesk_btn') != null) {
        document.getElementById('udesk_btn').style.display = 'none';
      }

      if (document.getElementById('zc__sdk__sys__btn') != null) {
        document.getElementById('zc__sdk__sys__btn').remove();
      }

      try {
        if (this.Getter_Socket_State) {
          this.init();
        }
      } catch (error) {
        throw error;
      }
    },
    beforeDestroy() {
      if (document.getElementById('udesk_btn') != null) {
        document.getElementById('udesk_btn').style.display = 'block';
      }
    },
    methods: {
      ...mapMutations([mutationTypes.SET_CURRENTMARKET]),
      async init() {
        if (this.Getter_Token) {
          this.getUserAccountData();
        }
        await this.onMounted();
        this.ready = true;
      },
      async onMounted() {
        await this.getMarketList();
        const currentPair = this.getCurrentMarket();
        let currentMarket = currentPair || this.Getter_Current_Market;
        if (!this.isEmpty(currentMarket)) {
          this.SET_CURRENTMARKET(currentMarket);
          this.activePair = currentMarket.symbol;
          this.activePairData = currentMarket;
          this.activePairGroup = currentMarket.marketCoin;
        } else {
          this.SET_CURRENTMARKET(this.provider.activePair);
          this.activePair = this.provider.activePair.symbol;
          this.activePairData = this.provider.activePair;
          this.activePairGroup = this.provider.activePairGroup;
        }

        this.options.depth = this.getDepthGroupList();

        if (!this.activeDepth) {
          this.activeDepth = this.options.depth[this.options.depth.length - 1].value;
        }

        this.activeInterval = this.klineIntervalMap(window.localStorage.getItem('chart.interval'));

        this.watch(this.activePair, this.activeDepth, this.activeInterval);
      },

      //misc
      klineIntervalMap(value) {
        let periodMap = {
          '1M': '1mn',
          '1W': '1w',
          // "03d": "3day",
          '1D': '1d',
          '720': '12h',
          '480': '8h',
          '360': '6h',
          '240': '4h',
          '120': '2h',
          '60': '1h',
          '30': '30m',
          '15': '15m',
          '5': '5m',
          // "3": "3min",
          '1': '1m'
        };
        return periodMap[value];
      },
      getDepthGroupList() {
        const arr = this.activePairData.mergeDepth.split(',').reverse();
        let response = [];

        for (let i = 0; i < arr.length; i++) {
          const item = Number(arr[i]);
          let text = '';
          let value = '';
          //convert to decimals
          if (0 < item) {
            text = 1 / Math.pow(10, item);
            value = `D${item}`;
          } else {
            text = Math.pow(10, -item);

            if (0 == item) {
              value = `I1`;
            } else {
              value = `I${Math.pow(10, -item)}`;
            }
          }

          response.push({
            text,
            value
          });
        }
        return response;
      },
      getCurrentMarket() {
        let symbol = null;
        const marketList = this.provider.marketList;
        if (this.$route.query && this.$route.query.pair) {
          symbol = this.$route.query.pair.toUpperCase();
        } else {
          return null;
        }

        for (let key in marketList) {
          for (let pair of Object.keys(marketList[key])) {
            if (symbol === pair) {
              return marketList[key][pair];
            }
          }
        }
        return null;
      },
      async getUserAccountData() {
        let res = await assetsApi.summaryFlow_api.getAccountAsset2();
        this.userAccountData = res.data;
      },
      convertPair(market) {
        if (!market) {
          return '';
        }
        return market.coin + '/' + market.marketCoin;
      },
      convertDecimal(value, decimal) {
        return tool.decimalRetain(parseFloat(value), decimal);
      },
      kLineTypeClick(type) {
        type = type * 1;
        const query = {
          pair: this.Getter_Current_Market.symbol,
          kLineType: type
        };
        this.$router.replace({
          path: '/exchange',
          query: { ...query }
        });
        // this.$router.replace(`/exchange/${this.currentMarket.symbol}?kLineType=${type}`);
        this.kLineTypeChange(type);
      },
      kLineTypeChange(kLineType) {
        if (typeof kLineType === 'undefined') {
          kLineType = typeof this.$route.params.kLineType !== 'undefined' ? this.$route.params.kLineType * 1 : 1;
          if (isNaN(kLineType)) {
            kLineType = 1;
          }
        }
        /* if(this.kLineType == kLineType){
             return;
           } */
        switch (kLineType) {
          case 1:
            this.chartView = 'kline';
            break;
          case 2:
            this.chartView = 'originKline';
            break;
          case 3:
            this.chartView = 'depth';
            break;
          default:
            this.chartView = 'kline';
        }
        this.kLineType = kLineType;
      },
      subscribeExchange(pair, interval) {
        this.getRealTimeExchangeData(pair, this.activeDepth, interval);
      },
    },
    data() {
      return {
        context: null,
        activeDepth: null,
        activeInterval: null,
        activePair: null,
        activePairData: null,
        activePairGroup: null,
        ready: false,
        options: {
          depth: null
        },
        chartView: 'kline',
        tradeViewExpand: 0,
        price: null,
        volume: null,
        bestPrice: {
          bestBuy: null,
          bestSell: null
        },
        lockActiveDepthWatch: false,
        userAccountData: []
      };
    }
  };
</script>

<style lang="stylus" scoped>
  @import './exchange.styl';

  table th, table td {
    vertical-align: top;
    border: 1px solid black;
    padding: 5px;
  }
</style>

<style lang="stylus">
  body {
    overflow: auto;
    background-color: #0e171e;
  }

  .chart-toggle-bar {
    font-size: 12px;
    margin-right: 12px;
    margin-top: 0;
    display: flex;
  }

  .chart-toggle-bar > .chart-toggle-btn {
    border: 1px solid #999;
    background-color: #1c2a34;
    color: #b0bec5;
    padding: 2px 12px;
    display: inline-block;
  }

  .chart-toggle-bar > .chart-toggle-btn:first-child {
    margin-left: auto;
  }

  .chart-toggle-bar > .chart-toggle-btn.active {
    background-color: #3a5dab;
    font-weight: bold;
  }

  .ping-pong.ping {
    background-color: green;
  }

  .ping-pong.pong {
    background-color: red;
  }

  .ping-pong {
    opacity: 0.4;
    width: 8px;
    height: 8px;
  }

  .ping-pong[data-active='true'] {
    opacity: 1;
  }

  [data-ping-pong='connected'] {
    background-color: green;
  }

  [data-ping-pong='disconnected'] {
    background-color: red;
  }

  [data-ping-pong='pong'] {
    background-color: #91ff91;
  }
</style>
